export const AlignLeftIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    width="16"
    height="16"
    className={className}
    style={{ display: "block" }}
  >
    <path
      d="M1.3335 14.6654V1.33203H2.66683V14.6654H1.3335ZM4.00016 11.332V9.33203H10.6668V11.332H4.00016ZM4.00016 6.66536V4.66536H14.6668V6.66536H4.00016Z"
      fill="#1A2547"
    />
  </svg>
);
